import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { ImplicitAuthWidget } from 'containers/ImplicitAuthWidget';
import { setAuthTimestamp } from 'utils/authTimestampUtils';
import { ProdStackManagerContentLayoutComponent } from 'design/prodStackManagerLayout';

export const ProdStackManagerContentGuest = () => {
  const dispatch = useAppDispatcher();

  const handleEmailConfirmed = React.useCallback(() => {
    dispatch({
      name: 'ProdStackManager__EmailConfirmed',
    });
  }, [dispatch]);

  React.useLayoutEffect(() => {
    setAuthTimestamp(new Date().toISOString());
  }, []);

  return (
    <ProdStackManagerContentLayoutComponent>
      <ImplicitAuthWidget
        target="PROD"
        onEmailConfirmed={handleEmailConfirmed}
      />
    </ProdStackManagerContentLayoutComponent>
  );
};
